import React, { useState } from "react";
import { FaMinus, FaPlus,  FaShieldAlt,FaLock, FaKey, FaFingerprint, FaUserShield, FaDatabase, FaClipboardCheck,FaBug, FaUserSecret, FaUserCheck, FaEye, FaExclamationTriangle, FaSyncAlt } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcareDataSecurity/Cyber.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Real-Time Threat Detection",
        "description": "Continuously monitors network traffic, system activity, and user behaviors using AI-driven threat intelligence and behavioral analytics. Detects and prevents cyber threats such as ransomware, phishing attacks, and unauthorized data access before they escalate. Ensures compliance with HIPAA, GDPR, and other industry security regulations to safeguard sensitive healthcare data."
    },
    {
        "title": "AI-Powered Security Analytics",
        "description": "Leverages artificial intelligence (AI) and machine learning (ML) to analyze massive volumes of healthcare data, detect anomalies, and predict potential cyber threats. AI-driven security models enhance real-time threat visibility, automate incident detection, and reduce response times against sophisticated cyberattacks, improving overall cybersecurity resilience."
    },
    {
        "title": "Incident Response & Threat Mitigation",
        "description": "Implements a structured approach to swiftly identifying, containing, and neutralizing cybersecurity incidents. Features include automated alerting, digital forensics, incident triage, and predefined response protocols. AI-driven automation enhances rapid containment of security breaches, minimizing downtime and safeguarding healthcare operations from disruption."
    },
    {
        "title": "Intrusion Detection & Prevention Systems (IDPS)",
        "description": "Deploys both network-based and host-based IDPS solutions to monitor and analyze system activities for unauthorized access attempts and malicious activities. Utilizes signature-based, anomaly-based, and behavior-based detection to proactively block cyber threats, ensuring continuous protection of electronic health records (EHRs) and IT infrastructure."
    },
    {
        "title": "Security Information & Event Management (SIEM)",
        "description": "Aggregates and analyzes security event logs from firewalls, medical devices, cloud services, and healthcare IT systems. AI-powered SIEM platforms correlate data in real time, detect advanced persistent threats (APTs), and automate response actions to prevent cyberattacks. Enhances regulatory compliance and operational efficiency with proactive security monitoring."
    },
    {
        "title": "24/7 Cybersecurity Monitoring",
        "description": "Provides round-the-clock surveillance of healthcare IT systems with a combination of AI-powered monitoring tools and cybersecurity experts. Features include real-time alerts, proactive threat hunting, continuous vulnerability assessment, and ransomware detection. Ensures uninterrupted protection of patient data and critical medical infrastructure from cyber threats."
    }
]


const features = [
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "RBAC ensures only authorized personnel access critical data." },
    { icon: <FaFingerprint className="text-[#2a627a] text-lg" />, text: "Biometric authentication enhances security and user identity verification." },
    { icon: <FaKey className="text-[#2a627a] text-lg" />, text: "Encryption-based access control secures medical records and devices." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "HIPAA-compliant access policies prevent unauthorized data breaches." },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "MFA adds an extra layer of security to prevent unauthorized logins." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Real-time monitoring detects and responds to security threats." }
];

const benefits = [
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Prevents data breaches and protects sensitive patient records." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Strengthens compliance with HIPAA, GDPR, and healthcare security regulations." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Reduces cybersecurity risks through proactive threat detection." },
    { icon: <FaExclamationTriangle className="text-[#2a627a] text-lg" />, text: "Identifies potential cyber threats before they can cause damage." },
    { icon: <FaUserSecret className="text-[#2a627a] text-lg" />, text: "Prevents unauthorized access by detecting insider threats and external attacks." },
    { icon: <FaSyncAlt className="text-[#2a627a] text-lg" />, text: "Enhances system resilience by continuously updating security protocols." }
];
const cmsFeatures = [
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Cybersecurity Analyst – Monitors and analyzes threats to prevent data breaches." },
    { icon: <FaBug className="text-[#2a627a] text-lg" />, text: "Threat Intelligence Specialist – Identifies emerging cybersecurity threats in healthcare." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "Network Security Engineer – Manages firewalls and intrusion detection systems." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Compliance Officer – Ensures healthcare security regulations are met." },
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Data Protection Officer – Oversees encryption and secure storage of patient records." },
    { icon: <FaEye className="text-[#2a627a] text-lg" />, text: "Incident Response Manager – Handles security breaches and develops mitigation plans." }
];

const CTM = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex"> Cyber Threat Monitoring in Healthcare - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Cyber Threat Monitoring continuously detects and responds to potential security threats, safeguarding healthcare systems from cyberattacks."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Cyber Threat Monitoring?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Cyber Threat Monitoring is a real-time security solution that continuously detects, analyzes, and responds to cyber threats targeting healthcare systems, EHRs, medical devices, and cloud infrastructure. It helps healthcare organizations identify vulnerabilities, prevent data breaches, and ensure compliance with security regulations like HIPAA, GDPR, and HITECH.

                            At HIKEHEALTH GS, we provide AI-driven, 24/7 cyber threat monitoring to safeguard patient data, telehealth platforms, and hospital networks from ransomware, phishing attacks, insider threats, and other cybersecurity risks.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in AccessControl
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default CTM;
